/* eslint-disable import/no-unresolved */
import { HeaderBackButton, HeaderBackButtonProps } from '@react-navigation/elements';
import { useMemo } from 'react';
import { I18nManager, Image, Platform, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  icon: {
    height: 21,
    width: 13,
    marginLeft: 8,
    marginRight: 22,
    marginVertical: 12,
    resizeMode: 'contain',
    transform: [{ scaleX: I18nManager.getConstants().isRTL ? -1 : 1 }],
  },
  iconWithLabel: {
    marginRight: 6,
  },
});

export default function CustomHeaderBackButton(props: HeaderBackButtonProps) {
  const getBackImage = useMemo(() => {
    return Platform.OS === 'ios'
      ? ({ tintColor }: { tintColor: string }) => (
          <Image
            fadeDuration={0}
            // eslint-disable-next-line global-require
            source={require('app/assets/icons/back-icon.png')}
            style={[
              styles.icon,
              Boolean(props.labelVisible) && styles.iconWithLabel,
              Boolean(tintColor) && { tintColor },
            ]}
          />
        )
      : undefined;
  }, [props.labelVisible]);

  return <HeaderBackButton {...props} backImage={getBackImage} />;
}
